import { EventEmitter, Injectable } from '@angular/core';
import { HttpService } from '@docpath/linces-angular-components/common';
import { Observable } from 'rxjs';
import { Constants } from 'src/app/constants/constants';

import { EndPoints } from '../../../constants/end-points';
import { HomeCardSearch } from '../models/home-card-statistics';
import { Hour } from '../models/hour';
import { StatisticsResult, StatisticsSearch } from '../models/statistics';
import { HomeService } from './home.service';

@Injectable({
    providedIn: 'root'
})
export class HomeHttpService {
    readonly relativeUrl = `${EndPoints.ENDPOINT_WEB_API}/${EndPoints.ENDPOINT_HOME}`;

    showLoadingTableChanged: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private readonly httpService: HttpService,
        private readonly homeService: HomeService
    ) { }

    getHour(loading: boolean, suscribe: (result: Hour[]) => void): void {

        // Show spinner loading only first time
        if (loading) {
            this.showLoadingTableChanged.emit(true);
        }

        this.httpService.get({
            relativeUrl: `${this.relativeUrl}/${EndPoints.ENDPOINT_HOME_HOUR}`,
            suscribe: response => {
                const hour = response.result as unknown as Hour[];
                this.showLoadingTableChanged.emit(false);
                this.homeService.homeTableReadyToRefresh();
                suscribe(hour);
            },
            suscribeOnError: () => {
                this.homeService.homeTableReadyToRefresh();
                this.showLoadingTableChanged.emit(false);
            }
        });
    }

    refreshHour(suscribe: (result: Hour[]) => void) {

        // Show spinner after a delay
        const idTimeout = setTimeout(() => this.showLoadingTableChanged.emit(true), Constants.REFRESH_SPINNER_DELAY);

        this.httpService.get({
            relativeUrl: `${this.relativeUrl}/${EndPoints.ENDPOINT_HOME_REFRESH_HOUR}`,
            suscribe: response => {
                const hour = response.result as unknown as Hour[];
                this.showLoadingTableChanged.emit(false);
                suscribe(hour);

                // Clear timeout
                clearTimeout(idTimeout);
            },
            suscribeOnError: () => {
                this.showLoadingTableChanged.emit(false);

                // Clear timeout
                clearTimeout(idTimeout);
            }
        });
    }

    getStatistics(search: StatisticsSearch): Observable<StatisticsResult[]> {

        return new Observable(observer => {
            const searchBase64 = btoa(JSON.stringify(search));

            this.httpService.get({
                relativeUrl: `${this.relativeUrl}/${EndPoints.ENDPOINT_HOME_CHARTS}`,
                queryParameters: { search: searchBase64 },
                suscribe: response => {
                    this.homeService.chartReadyToRefresh(search.key);
                    const result = response.result as unknown as StatisticsResult[];
                    observer.next(result);
                    observer.complete();
                }, suscribeOnError: () => {
                    this.homeService.chartReadyToRefresh(search.key);
                    observer.complete();
                }
            });
        });

    }

    getCardStatistics(search: HomeCardSearch, idCard: number): Observable<string> {

        return new Observable(observer => {
            const searchBase64 = btoa(JSON.stringify(search));

            this.httpService.get({
                relativeUrl: `${this.relativeUrl}/${EndPoints.ENDPOINT_HOME_CARD}`,
                queryParameters: { search: searchBase64 },
                suscribe: response => {
                    const result = response.result as unknown as string;
                    this.homeService.cardByNumberReadyToRefresh(idCard);
                    observer.next(result);
                    observer.complete();
                },
                suscribeOnError: () => {
                    this.homeService.cardByNumberReadyToRefresh(idCard);
                    observer.next('-');
                    observer.complete();
                }
            });
        });

    }
}